module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/easycredit_teaser_mit_elias_harris.jpg";